import type { ReactNode } from 'react';

/**
 * Rich-text tag renderers for `FormattedMessage`'s `values`. Spread the ones the message needs, alongside
 * any placeholder values: `values={{ ...boldChunk, ...paragraphChunk, time: remainingTime }}`.
 */

export const boldChunk = { b: (chunks: ReactNode) => <strong>{chunks}</strong> };

export const paragraphChunk = { p: (chunks: ReactNode) => <p>{chunks}</p> };

export const underlineChunk = { u: (chunks: ReactNode) => <u>{chunks}</u> };
